const CLASS_PILLAR_OFFER_BUTTON = '.button__pillar';

export default class MetaEventTracking {

  constructor() {
    this.init();
  }

  async init() {
    this.#isFbqset().then(() => {

      // Trackevent für click auf Button auf den Produktsäulen auf der Startseite
      let pillarButtons = document.querySelectorAll(CLASS_PILLAR_OFFER_BUTTON);
      pillarButtons.forEach(item => {
        item.addEventListener('click',  (event) => {
          this.track({
            'eventName': 'AddToCart',
            'name': item.getAttribute('data-product-name'),
            'id': item.getAttribute('data-product-id'),
            'value': item.getAttribute('data-product-value'),
            'ltv': item.getAttribute('data-product-ltv'),
            'category': item.getAttribute('data-product-category'),
          });
        });
      })

    })
  }

  track(eventObj) {

    switch (eventObj.eventName) {
      case 'AddToCart':
          window.fbq('track', 'AddToCart', {
            currency: "EUR",
            value: eventObj,
            predicted_ltv: eventObj.ltv,
            content_ids: eventObj.id,
            content_category: eventObj.category,
            content_name: eventObj.name,
        });
        break;
    }
  }

  async #isFbqset() {
    let oldSchoolWaiterCount = 0;
    return new Promise((resolve, reject) => {
      if (window.fbq != undefined) {
        resolve();
      } else {
        const oldSchoolWaiter = setInterval(function () {
          if (typeof fbq !== "undefined") {
            resolve();
            clearInterval(oldSchoolWaiter)
          } else if (oldSchoolWaiterCount > 10) {
            clearInterval(oldSchoolWaiter);
            reject('Timeout erreicht');
          } else {
            oldSchoolWaiterCount++
          }
        }, 500);
      }
    });
  }
}
